import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import * as pageData from "./PageData";

var myVar = null;

const underway = 0;
const promptIncomplete = 1;
const promptMoreTime = 2;

export default class VerbalReasoning extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
        this.handleModalProceed = this.handleModalProceed.bind(this);
        this.handleModalReturn = this.handleModalReturn.bind(this);

        const arr = [];

        for (let i = 0; i < pageData.verbalReasoningTestPages; i++) {
            arr.push(pageData.nullOption);
        }

        this.state = {
            memory: arr,
            secondsRemaining: 1200,
            completedState: underway
        };
    }

    componentDidMount() {
        this.afterUpdate();

        myVar = setInterval(this.updateTimer.bind(this), 1000);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    updateTimer() {
        const secondsRemaining = this.state.secondsRemaining;

        try {
            if (secondsRemaining > 0) {
                this.setState({ secondsRemaining: secondsRemaining - 1 });
            } else {
                clearTimeout(myVar);
                this.props.next({ response: pageData.skipRemaining });
            }
        } catch (e) {
            clearTimeout(myVar);
        }
    }

    optionChange(value) {
        const arr = this.state.memory;

        let temp = arr[this.props.content.index];

        if (this.props.content.responses === 1) {
            // single value

            temp = value;
        } else {
            // dual values, both between 1 and 6
            // value 1 stored * 10 (so 10, 20...)
            // e.g. 14 is values 1 and 4
            // Note: we keep value 1 lower, so 14 but not 41.

            let value1;
            let value2 = 0;

            if (temp === pageData.nullOption) {
                value1 = value;                     // value 1 on
            } else {
                value2 = temp % 10;
                value1 = (temp - value2) / 10;

                if (value === value1) {
                    value1 = value2;                // value 1 -> value 2
                    value2 = 0;
                } else if (value2 === 0) {
                    value2 = value;                 // value 2 on
                } else if (value === value2) {
                    value2 = 0;                     // value 2 off
                }
            }

            if (value1 === 0 && value2 === 0) {
                temp = pageData.nullOption;
            } else if (value1 < value2 || value2 === 0) {
                temp = (value1 * 10) + value2;
            } else {
                temp = (value2 * 10) + value1;
            }
        }

        arr[this.props.content.index] = temp;

        this.setState({ memory: arr });
    }

    handleModalProceed() {
        /*if (this.state.completedState === promptIncomplete) {*/
            /*this.props.next({ response: pageData.skipRemaining });*/
           /* this.props.next({ response: this.state.memory[this.props.content.index] });
        } else {
            this.props.next({ response: this.state.memory[this.props.content.index] });
        }*/

        let response = this.state.memory[this.props.content.index];

        if (response !== pageData.nullOption && response !== this.props.content.answer) {
            response *= -1;
        }

        this.props.next({ response: response });
    }

    handleModalReturn() {
        this.setState({ completedState: underway });
    }

    interceptClick(type) {
        if (type === "next") {
            let response = this.state.memory[this.props.content.index];

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }

            this.props.next({ response: response });
            return true;
        }
        else if (type === "back") {
            let response = this.state.memory[this.props.content.index];

            if (response == null || response == pageData.nullOption)
            {
                return false;
            }

            if (response !== pageData.nullOption && response !== this.props.content.answer) {
                response *= -1;
            }
            this.props.previous({ response: response });
            return false;
        }
        else if (type === "prev") {
            clearTimeout(myVar);
        }
        else if (type === "end") {
            const count = this.state.memory.reduce((accumulator, currentValue) => accumulator + (currentValue === pageData.nullOption ? 1 : 0), 0);

            if (count === 0) {
                this.setState({ completedState: promptMoreTime });
            } else {
                this.setState({ completedState: promptIncomplete });
            }
        }

        return false;
    }

    render() {
        const p = this.props;
        const optionChange = this.optionChange;
        const handleModalReturn = this.handleModalReturn;
        const handleModalProceed = this.handleModalProceed;

        const progressStyle = {
            width: `${p.content.index * (100 / pageData.verbalReasoningTestPages)}%`
        };

        return (
            <div className="test-page-content-inner test-page-verbal-reasoning">
                <div className="test-content">
                    {renderPractice(p, this.state, optionChange, handleModalReturn, handleModalProceed)}
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, optionChange, handleModalReturn, handleModalProceed) {
    const time = pageData.secondsToTime(state.secondsRemaining);

    return (
        <div className="test-content-inner">
            <h2 className="question-title">Question</h2>
            <div className="question">
                {props.content.question}
            </div>
            {renderTimer(time)}
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOptions(props.content.options, props, state, optionChange)}
            </div>
            {renderIncompleteModal(state, time, handleModalReturn, handleModalProceed)}
        </div>
    );
}

function renderIncompleteModal(state, time, handleModalReturn, handleModalProceed) {
    return (
        <Modal show={(state.completedState > underway)}>
            <Modal.Header>
                <Modal.Title>End Test</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderModalMessage(state, time)}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="default" onClick={handleModalReturn}>No thanks</Button>
                <Button bsStyle="success" onClick={handleModalProceed}>Yes, I'm sure</Button>
            </Modal.Footer>
        </Modal>
    );
}

function renderModalMessage(state, time) {
    if (state.completedState === promptIncomplete) {
        return (
            <div>Are you certain that you want to end the test without answering all the questions?</div>
        );
    }

    return (
        <div>You still have {time} left. Are you sure you want to end the test?</div>
    );
}

function renderOptions(elems, props, state, optionChange) {
    const sourceIndex = props.content.index;

    return elems.map(function (elem, index) {
        return renderOption(elem, props, state, sourceIndex, index + 1, optionChange);
    });
}

function renderOption(elem, props, state, sourceIndex, optionValue, optionChange) {
    const id = `option${sourceIndex}-${optionValue}`;
    const responses = props.content.responses;
    const temp = state.memory[sourceIndex];
    let checked;

    if (responses === 1) {
        checked = temp === optionValue ? "checked" : "";
    } else {
        const value2 = temp % 10;
        const value1 = (temp - value2) / 10;

        checked = value1 === optionValue || value2 === optionValue ? "checked" : "";
    }

    const disabled = props.waitingForSpeech ? 'disabled' : '';
    const type = responses === 1 ? "radio" : "checkbox";

    return (
        <div className="inputGroup" key={id}>
            <input id={id} type={type} name="option" value={optionValue} checked={checked} onChange={() => optionChange(optionValue)} disabled={disabled} />
            <label htmlFor={id}><span><span /></span></label>
            <span className="option-text">{elem.text}</span>
        </div>
    );
}

function renderTimer(time) {
    return (
        <div className="timer">
            <div className="timer-title">Time remaining:</div>
            <div className="timer-value">{time}</div>
        </div>
    );
}
